import React, { Component } from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { Switch, Route } from 'react-router';
import { authOperations } from '../redux/auth';
import { configOperations } from '../redux/config';
import { customFilterOperations } from '../redux/customFilter';
import { userOperations } from '../redux/user';
import { filterOperations } from '../redux/filter';
import { mapOperations } from '../redux/map';

import Splash from './Splash';
import ErrorPage from './Error';
import Login from './Login';
import Main from './Main';
import AuthManager from './esri/auth/AuthManager';
import { history } from '../index';

import './App.css';

class App extends Component {

  constructor(props) {

    super(props);
    this.props.fetchConfig();

    this.state = {
      useWVLogin: false,
      authStarted: false
    };

  }
  
  componentDidMount () {

    const urlSearchParams = new URLSearchParams(window.location.search);
    const useWVLogin = urlSearchParams.get('useWVLogin') === "true";

    this.setState({
      useWVLogin: useWVLogin
    });
  }

  componentDidUpdate(prevProps, prevState) 
  {

    const isLoaded = this.props.appConfig && this.props.appConfig.loaded;
    const authTried = this.props.auth && this.props.auth.loaded;
    const tryGroups = authTried && this.props.auth.user && this.props.auth.user.username && !this.props.auth.rolesLoaded;

    if (isLoaded && !authTried && !this.state.authStarted) 
    {
        window.authManager = new AuthManager(
          this.props.appConfig.appId[this.props.appConfig.env],
          this.props.appConfig.portalUrl,
          this.props.appConfig.jsapiUrl,
          this.props.appConfig.loginWithPopup,
          this.props.appConfig.use3D,
          this.state.useWVLogin
        );
        window.authManager.startup().then(this.props.checkAuth);
        this.setState({
          authStarted: true
        });
    }
    if(tryGroups)
    {
      this.loadPropsFromURL();

      window.api.getUserGroups(this.props.auth.user.username, this.state.useWVLogin).then(response => {

        const inReadOnlyGroup = response.groups.filter(group => { return group.id === this.props.appConfig.readOnlyGroupId[this.props.appConfig.env]}).length === 1;
        const inReadWriteGroup = response.groups.filter(group => { return group.id === this.props.appConfig.inspectorGroupId[this.props.appConfig.env]}).length === 1;
        const inCertifierGroup = response.groups.filter(group => { return group.id === this.props.appConfig.certifierGroupId[this.props.appConfig.env]}).length === 1;
        const inAdminGroup = response.groups.filter(group => { return group.id === this.props.appConfig.adminGroupId[this.props.appConfig.env]}).length === 1;

        const currentlyNonProduction = this.props.appConfig.env !== "prod";
        let inNoGroups = (!inReadOnlyGroup && !inReadWriteGroup && !inCertifierGroup);

        if (currentlyNonProduction && inNoGroups)
        {
            if (this.hasProductionRole(response.groups))
            {
              inNoGroups = false;
              this.props.setIsReadOnly(false);
            }
        }

        if (inNoGroups)
        {
          this.props.setNoRoles(true);
        }
        this.props.setIsCertifier(response.groups.filter(group => { return group.id === this.props.appConfig.certifierGroupId[this.props.appConfig.env]}).length === 1);
        this.props.setIsReadOnly(inReadOnlyGroup && !inReadWriteGroup);
        this.props.setIsAdmin(inAdminGroup);

        const apiUrl = this.props.appConfig.originApiUrl[this.props.appConfig.env];
        window.api.getUserSession(apiUrl).then(response => 
          {
            if (this.props.customFilter.customFilters && this.props.customFilter.customFilters.length > 0) 
            {
              window.api.importCustomFiltersFromReduxStore(apiUrl, this.props.customFilter.customFilters).then(response => {
                this.props.setCustomFilters(response);
                this.props.nukeFilters();
              }); 
            } 
            else 
            {
              this.props.setCustomFilters(response.CustomFilters);
            }
          });
      });
    }
  }

  hasProductionRole(groups)
  {
    const inProductionReadOnlyGroup = groups.filter(group => { return group.id === this.props.appConfig.readOnlyGroupId["prod"]}).length === 1;
    const inProductionReadWriteGroup = groups.filter(group => { return group.id === this.props.appConfig.inspectorGroupId["prod"]}).length === 1;
    const inProductionCertifierGroup = groups.filter(group => { return group.id === this.props.appConfig.inspectorGroupId["prod"]}).length === 1;

    return (inProductionReadOnlyGroup || inProductionReadWriteGroup || inProductionCertifierGroup);
  }

  loadPropsFromURL () {
    if(window.location.search) {
      const urlSearchParams = new URLSearchParams(window.location.search);
      const filterProps = urlSearchParams.get('filter');
      const mapProps = urlSearchParams.get('map');

      if(mapProps)
      {
        this.props.manualRehydrateMap(JSON.parse(mapProps));
      }
      if(filterProps)
      {
        this.props.manualRehydrateFilter(JSON.parse(filterProps));
      }
      history.push('/incidents');
    }
  }

  render() {
    // We'll use these to determine what state the app is in
    const configLoaded = this.props.appConfig.loaded;
    const authTried = this.props.auth.loaded;
    const isAuthenticated = this.props.auth.user && this.props.auth.user.username && this.props.auth.rolesLoaded;

    // Three possible states:
    //  1. App is initializing --> show splash component
    //  2. User is not logged in --> show login component
    //  3. User is logged in --> show Main component

    const hasError = false;
    if (hasError) {
      return <ErrorPage />
    }

    //
    // 1. App is initializing
    //
    if (!configLoaded || !authTried) {
      return <Splash />
    }
    //
    // 2. User is not logged in
    //
    else if (!isAuthenticated) {
      return (
        <div style={{height: '100%'}}>
          <Route path="/" component={Login} />
        </div>
      )
    }
    //
    // 3. User is logged in
    //
    else {
      return (
        <Switch>
          <Route path="/" component={Main} />
        </Switch>
      )
    }
  }
}

const mapStateToProps = state => ({
  auth: state.auth,
  appConfig: state.config,
  filter: state.filter,
  customFilter: state.customFilter,
  user: state.userOperations
})

const mapDispatchToProps = function (dispatch) {
  return bindActionCreators({
    ...authOperations,
    ...configOperations,
    ...filterOperations,
    ...customFilterOperations,
    ...mapOperations,
    ...userOperations
  }, dispatch);
}

export default connect(mapStateToProps, mapDispatchToProps)(App)
